module.exports = __webpack_public_path__ + "img/imagen_pc.b300f315.png";